<script>
import Vue from 'vue'
import { getScreenSize } from './Tools/utils'
import DrawingBoard from './drawingBoard.js'
import { Toast } from 'bxs-ui-vue'
Vue.use(Toast)

export default {
  name: 'DrawingBoard',
  props: {
    isHost: Boolean
  },
  data() {
    return {
      canvasWidth: null,
      borderWidth: null
    }
  },
  created() {},
  mounted() {
    const size = getScreenSize()
    if (size.width > 320) {
      this.canvasWidth = 345
      this.borderWidth = (size.width - 345) / 2
    } else {
      this.canvasWidth = 290
      this.borderWidth = (size.width - 290) / 2
    }
    this.board = new DrawingBoard({
      el: '.drawing-board-wrap',
      height: size.height,
      isHost: this.isHost,
      sendDrawingDelta: this.sendDrawingDelta.bind(this)
    })
  },
  methods: {
    syncClearRect() {
      this.board.clean()
    },
    handleStart(e) {
      this.board.handleStart(e)
    },
    handleMove(e) {
      this.board.handleMove(e)
    },
    handleEnd(e) {
      this.board.handleEnd(e)
    },
    sendDrawingDelta(delta) {
      if (this.isHost && JSON.stringify(delta).length > 9000) {
        this.$toast('绘制内容超过限制，请关闭画笔重新绘制')
        return
      }
      this.$emit('send-delta', delta)
    }
  }
}
</script>
<template>
  <div class="drawing-board-wrap">
    <div class="btn-container" />
    <div class="option-container">
      <div class="size-option">
        <div class="tip-box">
          <div class="tip" />
        </div>
        <div class="size-slider-box" />
      </div>
      <div class="color-option" />
    </div>
    <div class="function-container">
      <div class="recall no-recall">
        <svg
          t="1587883217931"
          class="icon"
          viewBox="0 0 1024 1024"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          p-id="6444"
          width="26"
          height="26"
        >
          <path
            d="M426.053024 331.626933l0-169.619142-331.490833 300.725132 331.490833 300.789601L426.053024 581.63394c92.097558 0 376.594077 0 499.373425 281.257755l0-31.251771C925.426449 706.636932 802.629705 305.014832 426.053024 331.626933z"
            p-id="6445"
            fill="#707070"
          />
        </svg>
      </div>
      <div class="recall-back no-recall-back">
        <svg
          t="1587883217931"
          class="icon"
          viewBox="0 0 1024 1024"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          p-id="6444"
          width="26"
          height="26"
        >
          <path
            d="M426.053024 331.626933l0-169.619142-331.490833 300.725132 331.490833 300.789601L426.053024 581.63394c92.097558 0 376.594077 0 499.373425 281.257755l0-31.251771C925.426449 706.636932 802.629705 305.014832 426.053024 331.626933z"
            p-id="6445"
            fill="#707070"
          />
        </svg>
      </div>
      <div class="save">
        <svg
          t="1587883723880"
          class="icon"
          viewBox="0 0 1024 1024"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          p-id="10004"
          width="22"
          height="22"
        >
          <path
            d="M347.733333 132.266667h324.266667c19.2 0 34.133333 17.066667 34.133333 40.533333s-14.933333 40.533333-34.133333 40.533333H347.733333c-19.2 0-34.133333-17.066667-34.133333-40.533333s14.933333-40.533333 34.133333-40.533333z m0 117.333333h324.266667c19.2 0 34.133333 17.066667 34.133333 40.533333s-14.933333 40.533333-34.133333 40.533334H347.733333c-19.2 0-34.133333-17.066667-34.133333-40.533334s14.933333-40.533333 34.133333-40.533333z m544 322.133333L546.133333 945.066667l-19.2 23.466666c-6.4 8.533333-29.866667 8.533333-38.4-2.133333l-21.333333-23.466667L128 571.733333c-29.866667-32-17.066667-57.6 25.6-57.6h136.533333c10.666667 0 19.2-8.533333 19.2-19.2v-83.2c0-10.666667 8.533333-19.2 19.2-19.2h356.266667c10.666667 0 19.2 8.533333 19.2 19.2v81.066667c0 10.666667 8.533333 19.2 19.2 19.2h140.8c46.933333 0 57.6 27.733333 27.733333 59.733333z"
            fill="#707070"
            p-id="10005"
          />
        </svg>
      </div>
    </div>
    <div class="canvas-container">
      <canvas class="front-canvas" />
      <canvas class="main-canvas" />
    </div>
  </div>
</template>
<style scoped>
.btn-container {
  padding: 10px 5px;
  display: flex;
  > * {
    border-radius: 4px;
    background-color: #fff;
    border: 1px solid #ccc;
  }
  > * + * {
    margin-left: 5px;
  }
  .active {
    border: 1px solid #333;
  }
}
.option-container {
  padding: 10px 20px;
  > div {
    display: none;
  }
  .active {
    display: block;
  }
}
.function-container {
  display: flex;
  justify-content: flex-end;

  > div {
    width: 30px;
    height: 30px;
    cursor: pointer;
  }
  .save {
    display: none;
  }
  .recall {
    display: inline-block;
    opacity: 1;
  }
  .no-recall {
    opacity: 0.2;
  }
  .recall-back {
    display: inline-block;
    opacity: 1;
    transform: rotateY(180deg);
  }
  .no-recall-back {
    opacity: 0.2;
  }
  .no-mouse {
    cursor: none;
  }
}
.canvas-container {
  overflow: hidden;
  position: relative;
  z-index: 99;
  overflow: hidden;
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  height: 100%;
  width: 100%;

  .front-canvas {
    z-index: 2;
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
  }
  .main-canvas {
    height: 100%;
    z-index: 1;
  }
}
</style>
<style>
.bx-toast {
  z-index: 1101 !important;
}
</style>
